
import Hierarchy2 from "../../../assets/filled/Hierarchy2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Hierarchy2Icon({ className, dataTestid = "Hierarchy2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Hierarchy2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
